export default __webpack_public_path__ + "static/media/bumblebee.503f5a95.png";